// actions.js
import {
    FETCH_COURSES_REQUEST,
    FETCH_COURSES_SUCCESS,
    FETCH_COURSES_FAILURE,
    ADD_COURSE_REQUEST,
    ADD_COURSE_SUCCESS,
    ADD_COURSE_FAILURE,
    UPDATE_COURSE_REQUEST,
    UPDATE_COURSE_SUCCESS,
    UPDATE_COURSE_FAILURE,
    DELETE_COURSE_REQUEST,
    DELETE_COURSE_SUCCESS,
    DELETE_COURSE_FAILURE,
  } from './actionTypes';
  
  // Fetch courses
  export const fetchCoursesRequest = (params) => ({
    type: FETCH_COURSES_REQUEST,
    payload: params, // e.g., pagination, filters
  });
  
  export const fetchCoursesSuccess = (courses) => ({
    type: FETCH_COURSES_SUCCESS,
    payload: courses,
  });
  
  export const fetchCoursesFailure = (error) => ({
    type: FETCH_COURSES_FAILURE,
    payload: error,
  });
  
  // Add course
  export const addCourseRequest = (course, onClose) => ({
    type: ADD_COURSE_REQUEST,
    payload: { course, onClose },
  });
  
  export const addCourseSuccess = (course) => ({
    type: ADD_COURSE_SUCCESS,
    payload: course,
  });
  
  export const addCourseFailure = (error) => ({
    type: ADD_COURSE_FAILURE,
    payload: error,
  });
  
  // Update course
  export const updateCourseRequest = (id, course, onClose) => ({
    type: UPDATE_COURSE_REQUEST,
    payload: { id, course, onClose },
  });
  
  export const updateCourseSuccess = (course) => ({
    type: UPDATE_COURSE_SUCCESS,
    payload: course,
  });
  
  export const updateCourseFailure = (error) => ({
    type: UPDATE_COURSE_FAILURE,
    payload: error,
  });
  
  // Delete course
  export const deleteCourseRequest = (courseId) => ({
    type: DELETE_COURSE_REQUEST,
    payload: courseId,
  });
  
  export const deleteCourseSuccess = (courseId) => ({
    type: DELETE_COURSE_SUCCESS,
    payload: courseId,
  });
  
  export const deleteCourseFailure = (error) => ({
    type: DELETE_COURSE_FAILURE,
    payload: error,
  });
  

  import {
  FETCH_COURSES_DROPDOWN_REQUEST,
  FETCH_COURSES_DROPDOWN_SUCCESS,
  FETCH_COURSES_DROPDOWN_FAILURE,
} from './actionTypes';

// Fetch courses dropdown
export const fetchCoursesDropdownRequest = () => ({
  type: FETCH_COURSES_DROPDOWN_REQUEST,
});

export const fetchCoursesDropdownSuccess = (courses) => ({
  type: FETCH_COURSES_DROPDOWN_SUCCESS,
  payload: courses,
});

export const fetchCoursesDropdownFailure = (error) => ({
  type: FETCH_COURSES_DROPDOWN_FAILURE,
  payload: error,
});
